import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/logo.png'


const _hoisted_1 = { class: "w-full max-h-full h-screen" }
const _hoisted_2 = { class: "pt-0 flex flex-col items-center max-h-full" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", {
  class: "py-10 max-h-full object-contain",
  src: _imports_0
}, null, -1)
const _hoisted_4 = { class: "p-10 text-white text-center" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-check mr-2" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("header", {
    class: "flex flex-col items-center justify-center bg-cover bg-center bg-no-repeat",
    style: _normalizeStyle({ backgroundImage: 'url(' + require(`@/assets/background.jpg`) + ')' })
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("button", {
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($options.scrollToForm && $options.scrollToForm(...args))),
            class: "mt-10 px-6 py-4 bg-white border-white hover:bg-black text-xl text-black font-semibold hover:text-white border rounded"
          }, [
            _hoisted_5,
            _createTextVNode("ACREDITARME ")
          ])
        ])
      ])
    ])
  ], 4))
}